import { createFileRoute } from '@tanstack/react-router'
import EditionsGridSearch from 'Edition/components/search/EditionsGridSearch'

export const Route = createFileRoute('/_editionsearch/work/editions')({
    validateSearch: (search: Record<string, string>) => search,
    component: EditionsGridSearch,
})
